module.exports = __webpack_public_path__ + "static/media/MyInstitute.666cbf03.svg";